import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMyProfile } from "../../redux/employeeSlice";
import styles from "./EmployeeDashboard.module.css";

export default function EmployeeDashboard() {
  const dispatch = useDispatch();
  const { myProfile, loading } = useSelector((state) => state.employees);

  useEffect(() => {
    dispatch(fetchMyProfile());
  }, [dispatch]);

  if (loading && !myProfile) {
    return <div className={styles.loading}>Loading your profile...</div>;
  }

  const profile = myProfile || {};

  return (
    <div className={styles.dashboard}>
      <div className={styles.cardsGrid}>
        <div className={styles.card}>
          <span className={styles.cardIcon}>👤</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Name</span>
            <span className={styles.cardValue}>{profile.name || "—"}</span>
          </div>
        </div>

        <div className={styles.card}>
          <span className={styles.cardIcon}>📧</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Email</span>
            <span className={styles.cardValue}>{profile.email || "—"}</span>
          </div>
        </div>

        <div className={styles.card}>
          <span className={styles.cardIcon}>🏢</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Department</span>
            <span className={styles.cardValue}>{profile.department || "—"}</span>
          </div>
        </div>

        <div className={styles.card}>
          <span className={styles.cardIcon}>💼</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Designation</span>
            <span className={styles.cardValue}>{profile.designation || "—"}</span>
          </div>
        </div>

        <div className={styles.card}>
          <span className={styles.cardIcon}>🆔</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Employee ID</span>
            <span className={styles.cardValue}>{profile.employeeId || "—"}</span>
          </div>
        </div>

        <div className={styles.card}>
          <span className={styles.cardIcon}>📱</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Phone</span>
            <span className={styles.cardValue}>{profile.phone || "—"}</span>
          </div>
        </div>

        <div className={styles.card}>
          <span className={styles.cardIcon}>🎯</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Role</span>
            <span className={styles.cardValue}>{profile.role ? profile.role.toUpperCase() : "—"}</span>
          </div>
        </div>

        <div className={styles.card}>
          <span className={styles.cardIcon}>✅</span>
          <div className={styles.cardBody}>
            <span className={styles.cardLabel}>Status</span>
            <span className={`${styles.cardValue} ${styles[profile.status]}`}>
              {profile.status ? profile.status.toUpperCase() : "—"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
